import { HostEvent as e } from "./HostEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/host/HostEventPayloads.ts
var n = t.object({ listingId: t.string().uuid() }), r = t.object({
	listingId: t.string().uuid(),
	fromDate: t.string().datetime(),
	toDate: t.string().datetime()
}), i = t.object({
	bookingId: t.string().uuid(),
	listingId: t.string().uuid()
}), a = t.object({
	bookingId: t.string().uuid(),
	listingId: t.string().uuid(),
	reason: t.string().optional()
}), o = t.object({ source: t.string().optional() }), s = {
	[e.ListingCreated]: n,
	[e.ListingPublished]: n,
	[e.ListingUnpublished]: n,
	[e.AvailabilityUpdated]: r,
	[e.BookingAccepted]: i,
	[e.BookingDeclined]: a,
	[e.DashboardViewed]: o
};
//#endregion
export { s as HostEventSchemas };
